var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-value": _vm.theme, "data-real": _vm.realTheme() } },
    [
      _c(
        "label",
        { staticClass: "light", attrs: { "aria-label": "Светлая тема" } },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.theme,
                expression: "theme",
              },
            ],
            attrs: { type: "radio", value: "light" },
            domProps: { checked: _vm._q(_vm.theme, "light") },
            on: {
              change: function ($event) {
                _vm.theme = "light"
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "auto",
          attrs: { "aria-label": "Автоматически определять тему" },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.theme,
                expression: "theme",
              },
            ],
            attrs: { type: "radio", value: "auto" },
            domProps: { checked: _vm._q(_vm.theme, "auto") },
            on: {
              change: function ($event) {
                _vm.theme = "auto"
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "dark", attrs: { "aria-label": "Тёмная тема" } },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.theme,
                expression: "theme",
              },
            ],
            attrs: { type: "radio", value: "dark" },
            domProps: { checked: _vm._q(_vm.theme, "dark") },
            on: {
              change: function ($event) {
                _vm.theme = "dark"
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }